<template>
  <v-layout row wrap>
    <v-flex xs12 sm4 lg4 d-flex>
      <v-select
        outline
        v-model="selectedFiltersGen.date_time"
        :items="timePeriodsGen.data"
        item-text="name"
        item-value="value"
        :label="translation('filter.time-periods.label')"
        :hint="hint"
        persistent-hint
        :disabled="timePeriodsGen.disabled"
        @change="toggleTimePeriods">
      </v-select>
    </v-flex>
    <v-flex xs12 sm4 lg4>
      <v-menu
        outline
        ref="dateFromMenu"
        v-model="dateFromMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field
            outline
            v-model="dateFromPicker"
            :label="translation('filter.time-start.label')"
            :hint="translation('filter.time-start.hint')"
            persistent-hint
            prepend-icon="event"
            readonly
            :disabled="timePeriodsGen.disabled"
            @blur="dateFromPicker = parseDate(selectedFiltersGen.date_time[0], 'YYYY-MM-DD')"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="dateFromPicker"
          :max="dateToPicker"
          no-title
          :locale="currentLanguage"
          @input="fromDateSelected"
        ></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs12 sm4 lg4>
      <v-menu
        ref="dateToMenu"
        v-model="dateToMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field
            outline
            v-model="dateToPicker"
            :label="translation('filter.time-end.label')"
            :hint="translation('filter.time-end.hint')"
            persistent-hint
            prepend-icon="event"
            readonly
            :disabled="timePeriodsGen.disabled"
            @blur="dateToPicker = parseDate(selectedFiltersGen.date_time[1], 'YYYY-MM-DD')"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="dateToPicker"
          :min="dateFromPicker"
          no-title
          :locale="currentLanguage"
          @input="toDateSelected"
        ></v-date-picker>
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import _ from 'underscore'

export default {
  name: 'FilterDateTime',
  props: {
    filterId: { type: String, required: false },
    filterKey: { type: String, required: false },
    filterName: { type: String, required: false }
  },
  data () {
    return {
      id: 'date_time',
      key: 'filterDateTime',
      dateFromMenu: false,
      dateToMenu: false,
      hint: this.$store.getters.translation('filter.time-periods.hint')
    }
  },
  computed: {
    ...mapGetters(['selectedFiltersGen', 'timePeriodsGen', 'translation', 'currentLanguage']),
    dateFromPicker: {
      get () { return this.$store.getters.dateFromPickerGen },
      set (val) { this.$store.commit('GEN_SET_DATE_FROM_PICKER', val) }
    },
    dateToPicker: {
      get () { return this.$store.getters.dateToPickerGen },
      set (val) { this.$store.commit('GEN_SET_DATE_TO_PICKER', val) }
    }
  },
  methods: {
    toggleTimePeriods () {
      const datePeriod = _.find(this.timePeriodsGen.data, period => period.value === this.selectedFiltersGen.date_time)
      this.dateFromPicker = this.parseDate(datePeriod.value[0], 'YYYY-MM-DD')
      this.dateToPicker = this.parseDate(datePeriod.value[1], 'YYYY-MM-DD')
      this.setFilterDateTime()
    },
    fromDateSelected () {
      let dateTime = []
      dateTime.push(moment(this.dateFromPicker).startOf('day').format('YYYY-MM-DD HH:mm:ss'))
      if (!this.dateToPicker) {
        dateTime.push(moment(this.dateFromPicker).endOf('day').add(30, 'days').format('YYYY-MM-DD HH:mm:ss'))
        this.dateToPicker = this.parseDate(dateTime[1], 'YYYY-MM-DD')
      } else {
        dateTime.push(moment(this.dateToPicker).endOf('day').format('YYYY-MM-DD HH:mm:ss'))
      }
      this.$store.commit('GEN_SET_SELECTED_FILTER_DATE_TIME', dateTime)
      this.dateFromMenu = false
      this.setFilterDateTime()
    },
    toDateSelected () {
      let dateTime = []
      if (!this.dateFromPicker) {
        dateTime.push(moment(this.dateToPicker).startOf('day').subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'))
        this.dateFromPicker = this.parseDate(dateTime[0], 'YYYY-MM-DD')
      } else {
        dateTime.push(moment(this.dateFromPicker).startOf('day').format('YYYY-MM-DD HH:mm:ss'))
      }
      dateTime.push(moment(this.dateToPicker).endOf('day').format('YYYY-MM-DD HH:mm:ss'))
      this.$store.commit('GEN_SET_SELECTED_FILTER_DATE_TIME', dateTime)
      this.dateToMenu = false
      this.setFilterDateTime()
    },
    parseDate (date, format) {
      if (!date) return null
      return moment(date).format(format)
    },
    setFilterDateTime () {
      // emit event for fetching data
      this.$emit('update-filter-date-time')
    }
  },
  created () {
    this.hint = this.filterName ? this.translation('filter.filter-by') + this.filterName : this.translation('filter.time-periods.hint')
    if (this.filterId) {
      this.$store.commit('GEN_SET_DATETIME_PARAM_NAME', this.filterId)
    }
    let defaultPeriod = _.find(this.timePeriodsGen.data, (period) => {
      return period.default === true
    })
    if (defaultPeriod) {
      this.selectedFiltersGen.date_time = [...defaultPeriod.value]
      this.dateFromPicker = this.parseDate(this.selectedFiltersGen.date_time[0], 'YYYY-MM-DD')
      this.dateToPicker = this.parseDate(this.selectedFiltersGen.date_time[1], 'YYYY-MM-DD')
      this.setFilterDateTime()
    }
  }
}
</script>

<style>
  .v-text-field .v-input__slot {
    border: 1px solid darkgray !important;
  }
</style>
